import React, { FC } from 'react';

import { theme } from '~/theme';

import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { Chip, IconButton, Link, TableCell as MUITableCell, TableRow, Typography } from '@mui/material';

import { Experiences } from '@luxuryescapes/contract-svc-experience';

import { currencyFormatter } from '../../../helpers';

type ExperienceListRowProps = {
  exp: Experiences.Offer;
  selectedExperiences: Array<Experiences.Offer>;
  addOnclick: (exp: Experiences.Offer) => void;
  removeOnclick: (exp: Experiences.Offer) => void;
};

const TableCell = ({ children, ...props }) => (
  <MUITableCell sx={{ padding: 1, fontSize: 16, verticalAlign: 'top', borderBottom: 'none' }} {...props}>
    {children}
  </MUITableCell>
);

const ExperienceListRow: FC<ExperienceListRowProps> = ({ exp, selectedExperiences, removeOnclick, addOnclick }) => {
  const selected = selectedExperiences.some((item) => item.id === exp.id);

  return (
    <TableRow
      sx={{
        background: theme.palette.grey[50],
        ':nth-of-type(even)': {
          background: theme.palette.grey[100],
        },
        ':hover': {
          background: theme.palette.grey[200],
        },
      }}
    >
      <TableCell width={1000}>
        <Link href={`/experience/${exp.id}`} target="_blank" rel="noopener noreferrer">
          <Typography>{exp.title}</Typography>
        </Link>
        <Typography variant="caption">{exp.id}</Typography>
      </TableCell>
      <TableCell width={200}>{exp.provider}</TableCell>
      <TableCell width={200}>
        {exp.expirationDate ? new Date(exp.expirationDate).toLocaleDateString() : 'Unlimited time'}
      </TableCell>
      <TableCell width={200}>{exp.score}</TableCell>
      <TableCell width={200}>{currencyFormatter(exp.pricing.currency, exp.pricing.salesPrice)}</TableCell>
      <TableCell width={200}>
        <Chip
          label={exp.status === 'ONLINE' ? 'Available' : 'Unavailable'}
          color={exp.status === 'ONLINE' ? 'success' : 'error'}
        />
      </TableCell>
      <TableCell width={200} style={{ textAlign: 'end' }}>
        <IconButton size="large" onClick={() => (selected ? removeOnclick(exp) : addOnclick(exp))}>
          {selected ? <RemoveCircleIcon /> : <AddCircleIcon color="info" />}
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export default ExperienceListRow;
